<div class="container pb-4 pt-4 ">
  <app-breadcrumb currentRouteName="À propos - Aide"></app-breadcrumb>
  <div class="pt-4">
    <div class="about-grid d-flex flex-md-row flex-column">
      <div>
        <div class="d-flex align-items-center justify-content-center flex-column block-shadow p-4 pl-5 pr-5 bg-white">
          <div class="align-self-baseline">
            <h3>Aide</h3>
          </div>
          <div class="embed-container">
            <video controls controlsList="nodownload">
              <source src="https://nexus.libriciel.fr/repository/ls-raw/public/interne/portail/video_portail_client_1_4.mp4"
                      type="video/mp4">
            </video>
          </div>

          <button (click)="downloadFile()" class="btn btn-primary mt-4">
            <fa-icon icon="download"></fa-icon>
            Documentation du portail
          </button>

          <p class="text text-info text-justify pt-4">Pour toute demande d'amélioration du Portail client ou question
            sur l'utilisation, merci d'envoyer un mail à
            <br/>
            <a style="text-decoration: underline;" href="mailto:contact.portail@libriciel.fr">contact.portail&#64;libriciel.fr</a>
          </p>

        </div>
      </div>

      <div class="block-shadow p-4 pl-5 pr-5 bg-white">
        <h3>Note de version</h3>

        <p>Version courante : <span class="font-weight-bold">1.4.0</span></p>

        <p class="font-weight-bold">[1.4.0] - 2026-09-24</p>

        <p>Évolutions</p>
        <ul style="font-size: small;">
          <li>Nouvelle page "Notes de version"</li>
          <li>[Tickets] Choix de la fiche d'installation</li>
          <li>Ajout champ recherche dans les documentations</li>
          <li>Informations visuelles pour nouvelles documentations et mises à jour</li>
          <li>Ajout bandeau évènement en cours</li>
          <li>Tablette : amélioration navigation dans la FAQ</li>
          <li>Surbrillance sur toutes les recherches</li>
        </ul>

        <p class="font-weight-bold">[1.3.0] - 2026-05-04</p>

        <p><i>Version non publiée</i></p>

        <p class="font-weight-bold">[1.2.0] - 2024-03-28</p>

        <p>Évolutions</p>
        <ul style="font-size: small;">
          <li>Mise à jour Bootstrap 5</li>
          <li>Mise à jour Angular 17</li>
          <li>Ajout d'une page "Contrats" avec utilisateurs associés et directrice de projet</li>
          <li>Amélioration de la gestion des utilisateurs Portail</li>
          <li>Ajout des demandes de modification des utilisateurs Portail</li>
          <li>Ajout d'une visionneuse PDF pour les documentations</li>
          <li>Ajout d'un bandeau d'actualité / événements</li>
          <li>Affichage des prestations planifiées, quelque soit le logiciel concerné</li>
          <li>Amélioration du marqueur visuel pour l'historique des informations en direct</li>
          <li>[Tickets] Affichage des produits concernés uniquement par le carnet de temps</li>
          <li>[Tickets] Réorientation des demandes commerciales</li>
        </ul>

        <p class="font-weight-bold">[1.1.0] - 2023-09-05</p>

        <p>Évolutions</p>
        <ul style="font-size: small;">
          <li>Mise à jour de Keycloak version 20</li>
          <li>Mise en cache des sessions utilisateurs</li>
          <li>Revue du design du mail de réinitialisation de mot de passe</li>
          <li>Amélioration de l'écran "mot de passe oublié"</li>
          <li>Bascule des urls en français</li>
          <li>Préférences utilisateur : demander la modification des éléments de mon compte</li>
          <li>Ajout outil PSITransfer dans la liste des outils</li>
          <li>Ajout de la page A propos / Aide pour afficher le journal des modifications</li>
          <li>Formulaire ajout utilisateur : indication en cas de champ oublié</li>
          <li>[Tickets] Ordonnancement des versions des produits</li>
          <li>[Tickets] Pouvoir répondre à tous systematiquement depuis la vue portail</li>
          <li>[Tickets] Ajout d'un commentaire explicatif pour le bouton "répondre et clore"</li>
          <li>[Tickets] Ajout d'un commentaire explicatif pour le bouton "répondre et relancer"</li>
          <li>[Tickets] Revue de la bascule des tickets de la structure</li>
          <li>[Tickets] Ajout de la fonctionnalité "tout déplier" / "tout replier"</li>
        </ul>
        <p>Corrections</p>
        <ul style="font-size: small;">
          <li>La recherche par mots clés ne fonctionnait pas dans les prestations planifiées</li>
          <li>Les prestations "en centre" étaient affichées comme "Prestation à distance"</li>
          <li>[Tickets] Les images ajoutées dans les tickets étaient parfois invisibles</li>
        </ul>
      </div>
    </div>
  </div>
</div>
